import components from './components.js';
import errors from './errors';
import paymentNetworks from './paymentNetworks/index';
import faqs from './faqs';

/* eslint no-template-curly-in-string: "off" */
// TODO: handle custom css styles in config
// TODO: create config.js file
// TODO: allow program configuration of timeout intervals
const config = {
  document: {
    title: "",
    favicon: null
  },
  styles: {
    title: {},
    description: {},
    secondaryText: {},
    paymentAmount: {},
    date: {},
    recipientEmail: {},
    networkDisplayName: {}
  },
  faqs,
  ...components,
  errors,
  paymentNetworks,
};

export default config;
